// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAbPeXLhX6Fb4dloET9CHH3217DwakkYkc",
  authDomain: "chatbot-demo-e27ce.firebaseapp.com",
  projectId: "chatbot-demo-e27ce",
  storageBucket: "chatbot-demo-e27ce.appspot.com",
  messagingSenderId: "661213456377",
  appId: "1:661213456377:web:1803f216c6009422507f28",
  measurementId: "G-597P1ELJ9R",
  databaseURL:"https://chatbot-demo-e27ce.firebaseio.com"
};

export default firebaseConfig